<template>
  <div
    v-if="!loading"
    class="box-container"
  >
    <d-header
      fluid
      :breadcrumbs="false"
    >
      <h2 class="title is-5">
        <d-previous-btn
          :path="'/owners/' + $route.params.owner + '/contacts'"
        />
        {{ model.name }}
      </h2>
    </d-header>

    <v-form
      ref="form"
      :model="model"
      action="edit"
      :owner_id="parseInt($route.params.owner)"
    />
  </div>
</template>

<script>
import form from "./_form.vue";

export default {
  components: {
    "v-form": form
  },
  data() {
    return {
      model: {},
      loading: true
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    }
  },
  watch: {
    "$route.params.OwnerContact"() {
      this.fetch();
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .get(
          this.$laravel.route("api.owner-contacts.show", {
            owner: this.$route.params.owner,
            owner_contact: parseInt(this.$route.params.id)
          })
        )
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch(e => {
          console.error(e);
          this.$router.push("/owners");
        });
    },
    submitForm() {
      this.$refs.form.$refs.form.submit();
    }
  }
};
</script>
